module.exports = __webpack_public_path__ + "static/media/ic-time-travel-menu.53351cc0.svg";